import * as searchActions from '../../../../../../constants/searchActions';
import React from 'react';
import {
  getCommonConfig,
  getIsAmazonInstalled,
  getIsBigCommerceInstalled,
  getIsCommonOrderSystemInstalled,
  getIsRbiInstalled,
  getIsRevolveInstalled,
  getIsSalesforceOrderManagerEnabled,
  getIsShopifyInstalled,
  getIsZendeskShopSelected,
  getSelectedOrderSearchAction,
} from '../../../../../../selectors/tools';
import { useSelector } from 'react-redux';
import { StyledDropdownSelect } from './SearchPageSelect.styles';
import { CoiOrderSearchOptions } from '../CoiOrderSearchOptions/CoiOrderSearchOptions';

export const SearchPageSelect = (props) => {
  const { onSelectAction } = props;

  const isShopifyInstalled = useSelector(getIsShopifyInstalled);
  const isAmazonInstalled = useSelector(getIsAmazonInstalled);
  const isZendeskShopSelected = useSelector(getIsZendeskShopSelected);
  const selectedSearchAction = useSelector(getSelectedOrderSearchAction);

  const isRbiInstalled = useSelector(getIsRbiInstalled);
  const isCommonOrderSystemInstalled = useSelector(getIsCommonOrderSystemInstalled);
  const isSalesforceOrderManagerEnabled = useSelector(getIsSalesforceOrderManagerEnabled);
  const isBigCommerceInstalled = useSelector(getIsBigCommerceInstalled);
  const isRevolveInstalled = useSelector(getIsRevolveInstalled);
  const commonConfig = useSelector(getCommonConfig);

  const isInCommonMode = (name) => commonConfig?.name === name;

  return (
    <StyledDropdownSelect onChange={onSelectAction} value={selectedSearchAction}>
      {isShopifyInstalled &&
        !isZendeskShopSelected &&
        !isInCommonMode('shopify') && [
          <option
            key={searchActions.SHOPIFY_ORDER_NUMBER}
            value={searchActions.SHOPIFY_ORDER_NUMBER}
            disabled={isZendeskShopSelected}
          >
            Get shopify order by number
          </option>,
          <option key={searchActions.SHOPIFY_EMAIL} value={searchActions.SHOPIFY_EMAIL}>
            Get shopify orders by email
          </option>,
          <option
            key={searchActions.SHOPIFY_PHONE_NUMBER}
            value={searchActions.SHOPIFY_PHONE_NUMBER}
            disabled={isZendeskShopSelected}
          >
            Get shopify orders by phone number
          </option>,
          <option
            key={searchActions.SHOPIFY_FULL_NAME}
            value={searchActions.SHOPIFY_FULL_NAME}
            disabled={isZendeskShopSelected}
          >
            Get shopify orders by 'firstname lastname'
          </option>,
        ]}
      {isAmazonInstalled && [
        <option key={searchActions.AMAZON_ORDER_NUMBER} value={searchActions.AMAZON_ORDER_NUMBER}>
          Get amazon order by number
        </option>,
      ]}
      {isCommonOrderSystemInstalled && <CoiOrderSearchOptions />}
      {isRbiInstalled && [
        <option key={searchActions.RBI_EMAIL} value={searchActions.RBI_EMAIL}>
          Get RBI order by email
        </option>,
        <option key={searchActions.RBI_CARD_ID} value={searchActions.RBI_CARD_ID}>
          Get RBI order by card ID
        </option>,
        <option key={searchActions.RBI_ID} value={searchActions.RBI_ID}>
          Get RBI order by order number
        </option>,
      ]}
      {isSalesforceOrderManagerEnabled && [
        <option key={searchActions.SALESFORCE_ORDER_EMAIL} value={searchActions.SALESFORCE_ORDER_EMAIL}>
          Get salesforce order by email
        </option>,
        <option key={searchActions.SALESFORCE_ORDER_ID} value={searchActions.SALESFORCE_ORDER_ID}>
          Get salesforce order by order id
        </option>,
      ]}
      {isBigCommerceInstalled &&
        !isInCommonMode('bigCommerce') && [
          <option key={searchActions.BIG_COMMERCE_ORDER_EMAIL} value={searchActions.BIG_COMMERCE_ORDER_EMAIL}>
            Get Big Commerce order by email
          </option>,
          <option key={searchActions.BIG_COMMERCE_ORDER_ID} value={searchActions.BIG_COMMERCE_ORDER_ID}>
            Get Big Commerce order by order id
          </option>,
        ]}
      {isRevolveInstalled &&
        !isInCommonMode('revolve') && [
          <option key={searchActions.REVOLVE_ORDER_EMAIL} value={searchActions.REVOLVE_ORDER_EMAIL}>
            Get Revolve order by email
          </option>,
          <option key={searchActions.REVOLVE_ORDER_ID} value={searchActions.REVOLVE_ORDER_ID}>
            Get Revolve order by order id
          </option>,
        ]}
    </StyledDropdownSelect>
  );
};
